"use client"

import { createPortal } from "react-dom"

interface RouteMapCloseButtonProps {
  open: boolean
  onClose: () => void
}

const buttonStyles: React.CSSProperties = {
  position: "fixed",
  right: "1rem",
  top: "1rem",
  zIndex: 2147483647,
  borderRadius: "9999px",
  background: "rgba(255, 255, 255, 0.95)",
  padding: "0.5rem",
  color: "#374151",
  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)",
  transition: "all 0.2s",
  cursor: "pointer",
  border: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "auto",
} as const

export function RouteMapCloseButton({ open, onClose }: RouteMapCloseButtonProps) {
  if (!open) return null

  return createPortal(
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); e.preventDefault(); onClose() }}
      aria-label="Fechar mapa"
      title="Fechar mapa"
      style={buttonStyles}
      onMouseEnter={(e) => { e.currentTarget.style.background = "white"; e.currentTarget.style.color = "#2563eb" }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255, 255, 255, 0.95)"; e.currentTarget.style.color = "#374151" }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>,
    document.body
  )
}